module.exports = __webpack_public_path__ + "img/Logo_GE_1.84cd461e.png";